var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tags-wrapper"},[_c('Tags',{attrs:{"onChange":_vm.onTagsChange,"settings":_vm.tagifySettings,"initial-value":_vm.initial}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }